var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgVision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 790,
    height: 756,
    viewBox: "0 0 790 756",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cod3iyyjpa",
    d: "M0 0L790 0 790 756 0 756z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y3985uuryc",
    d: "M0 0.219L96.042 0.219 96.042 129.871 0 129.871z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-810 -3940) translate(810 3940)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "kxn2wacexb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cod3iyyjpa"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#cod3iyyjpa"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#kxn2wacexb)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M252.381 625.381l88.118 52.843 88.117-52.843V519.616L340.5 466.774l-88.118 52.842V625.38zM340.5 681L250 626.73V518.267L340.499 464 431 518.267V626.73L340.499 681z",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M162.383 571.382l88.117 52.844 88.118-52.844V465.62L250.5 412.776l-88.117 52.843v105.763zM250.5 627L160 572.729V464.271L250.5 410l90.5 54.271v108.458L250.5 627z",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    d: "M162.383 678.379l88.117 52.844 88.118-52.844V572.617l-88.118-52.84-88.117 52.84V678.38zM250.5 734L160 679.728V571.27L250.5 517l90.5 54.27v108.458L250.5 734zM700.381 678.378l88.119 52.845 88.117-52.845V572.616L788.5 519.777l-88.119 52.84v105.761zM788.5 734L698 679.726V571.268L788.5 517l90.5 54.268v108.458L788.5 734z",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M700.381 571.38l88.119 52.846 88.117-52.845V465.619L788.5 412.776l-88.119 52.843V571.38zM788.5 627L698 572.728V464.271L788.5 410l90.5 54.271v108.457L788.5 627z",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    d: "M610.38 518.38l88.119 52.843 88.12-52.842V412.616l-88.12-52.84-88.119 52.84V518.38zM698.5 574L608 519.728v-108.46L698.499 357 789 411.268v108.46L698.499 574z",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M74.382 840.382l88.118 52.844 88.12-52.844V734.617l-88.12-52.843-88.118 52.843v105.765zM162.5 896L72 841.73V733.268L162.5 679l90.5 54.269v108.46L162.5 896z",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M342.382 786.378l88.116 52.848 88.12-52.848V680.615l-88.12-52.84-88.116 52.84v105.763zM430.498 842L340 787.728V679.266L430.498 625 521 679.266v108.462L430.498 842z",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E3",
    d: "M431.384 840.381l88.118 52.845 88.118-52.845V734.617l-88.118-52.842-88.118 52.842v105.764zM519.502 896L429 841.729v-108.46L519.502 679 610 733.269v108.46L519.502 896z",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M346.202 572.104c0-2.964-2.402-5.366-5.366-5.366-2.963 0-5.368 2.402-5.368 5.366 0 2.962 2.405 5.365 5.368 5.365 2.964 0 5.366-2.403 5.366-5.365",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    d: "M169.077 679.399c0-3.952-3.206-7.152-7.158-7.152-3.952 0-7.158 3.2-7.158 7.152s3.206 7.155 7.158 7.155c3.952 0 7.158-3.203 7.158-7.155",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M520.947 786.021l88.265 52.938 88.265-52.938V680.075l-88.265-52.932-88.265 52.932v105.946zm88.265 55.718l-90.652-54.367V678.724l90.652-54.36 90.65 54.36v108.648l-90.65 54.367z",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M524.525 679.399c0-2.634-2.137-4.767-4.77-4.767-2.638 0-4.773 2.133-4.773 4.767 0 2.635 2.135 4.77 4.772 4.77 2.634 0 4.77-2.135 4.77-4.77",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E3",
    d: "M524.525 572.104c0-2.633-2.137-4.768-4.77-4.768-2.638 0-4.773 2.135-4.773 4.768s2.135 4.768 4.772 4.768c2.634 0 4.77-2.135 4.77-4.768",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M432.084 411.158c0-.99-.803-1.789-1.79-1.789-.988 0-1.788.8-1.788 1.789 0 .987.8 1.786 1.787 1.786.988 0 1.791-.799 1.791-1.786",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M202.755 481.001L202.755 539.713 201.331 539.713 201.331 481.808 148.687 450.236 96.042 481.808 96.042 539.713 94.619 539.713 94.619 481.001 148.687 448.579z",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#969696",
    d: "M256.112 513.001L256.112 539.714 254.689 539.714 254.689 513.808 202.043 482.237 149.399 513.808 149.399 539.714 147.975 539.714 147.975 513.001 202.043 480.577z",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M0 473.75L41.262 449.005 41.262 385.814 0 361.069 0 359.409 42.686 385.009 42.686 449.811 0 475.409z",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 54) translate(0 320.366)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "tfp6c3ti4d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#y3985uuryc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#323232",
    d: "M96.042 32.644L96.042 97.445 41.975 129.871 0 104.698 0 103.039 41.975 128.212 94.619 96.638 94.619 33.448 41.975 1.878 0 27.049 0 25.39 41.975 0.219z",
    mask: "url(#tfp6c3ti4d)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M521.47 97.83l-52.643-31.572L416.18 97.83v63.19l52.646 31.573 52.643-31.573V97.83zm-106.712 63.995V97.024L468.827 64.6l54.066 32.424v64.801l-54.066 32.426-54.07-32.426z",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#323232",
    d: "M574.828 65.831l-52.646-31.569-52.645 31.57v63.19l52.645 31.572 52.646-31.571V65.83zM468.115 129.83V65.026l54.067-32.423 54.07 32.423v64.803l-54.07 32.424-54.067-32.424z",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#969696",
    d: "M574.828 129.829l-52.646-31.573-52.645 31.573v63.19l52.645 31.572 52.646-31.571v-63.191zm-106.713 63.996v-64.802l54.067-32.425 54.07 32.425v64.802l-54.07 32.425-54.067-32.425zM254.689 129.829l-52.646-31.573-52.644 31.573v63.19l52.644 31.572 52.646-31.572v-63.19zm-106.714 63.995v-64.801l54.068-32.425 54.069 32.425v64.801l-54.07 32.426-54.067-32.426z",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M254.689 65.833l-52.646-31.574-52.644 31.574v63.19l52.644 31.571 52.646-31.571v-63.19zm-106.714 63.996V65.026l54.068-32.423 54.069 32.423v64.803l-54.07 32.425-54.067-32.425z",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#969696",
    d: "M308.045 33.833L255.4 2.26l-52.645 31.572v63.19l52.645 31.573 52.645-31.572V33.833zM201.33 97.83V33.027L255.401.602l54.067 32.425V97.83L255.4 130.255 201.331 97.83z",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#323232",
    d: "M201.331 33.833L148.687 2.26 96.042 33.833v63.19l52.645 31.573 52.644-31.572V33.833zM94.618 97.83V33.027L148.688.602l54.067 32.425V97.83l-54.068 32.425L94.618 97.83z",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    d: "M521.47 417.811l-52.643-31.57-52.646 31.57v63.19l52.646 31.575 52.643-31.575v-63.19zm-106.712 63.996v-64.803l54.069-32.423 54.066 32.423v64.803l-54.066 32.426-54.07-32.426z",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#323232",
    d: "M468.115 385.814l-52.644-31.571-52.648 31.571v63.19l52.648 31.573 52.644-31.572v-63.19zM361.4 449.811v-64.802l54.07-32.425 54.066 32.425v64.802l-54.066 32.425-54.07-32.425zM308.043 353.815L255.4 322.244l-52.645 31.57v63.19l52.645 31.574 52.643-31.573v-63.19zM201.331 417.81V353.01l54.07-32.425 54.067 32.425v64.801L255.4 450.236l-54.069-32.425z",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#969696",
    d: "M254.689 257.82l-52.646-31.57-52.644 31.57v63.19l52.644 31.574 52.646-31.573v-63.19zm-106.714 63.997v-64.803l54.068-32.423 54.069 32.423v64.803l-54.07 32.425-54.067-32.425z",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#323232",
    d: "M201.331 225.821l-52.644-31.571-52.645 31.571v63.192l52.645 31.571 52.644-31.571V225.82zM94.618 289.818v-64.802l54.07-32.423 54.067 32.423v64.802l-54.068 32.425-54.069-32.425z",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    d: "M147.975 257.82l-52.644-31.57-52.645 31.57v63.19l52.645 31.574 52.644-31.573v-63.19zM41.263 321.817v-64.803l54.068-32.423 54.068 32.423v64.803L95.33 354.242l-54.068-32.425z",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#969696",
    d: "M147.975 385.814l-52.644-31.571-52.645 31.571v63.19l52.645 31.573 52.644-31.572v-63.19zM41.263 449.811v-64.802l54.068-32.425 54.068 32.425v64.802L95.33 482.236l-54.068-32.425zM147.975 193.824l-52.644-31.57-52.645 31.57v63.19l52.645 31.575 52.644-31.575v-63.19zM41.263 257.82V193.02l54.068-32.425 54.068 32.425v64.801L95.33 290.246 41.263 257.82z",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#969696",
    d: "M201.331 161.825l-52.644-31.57-52.645 31.57v63.191l52.645 31.574 52.644-31.574v-63.19zM94.618 225.821V161.02l54.07-32.424 54.067 32.424v64.801l-54.068 32.426-54.069-32.426z",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    d: "M414.757 289.818l-52.644-31.571-52.645 31.571v63.192l52.645 31.572 52.644-31.572v-63.192zm-106.712 63.997v-64.803l54.068-32.422 54.068 32.422v64.803l-54.068 32.426-54.068-32.426z",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#646464",
    d: "M308.045 289.818L255.4 258.247l-52.645 31.571v63.192l52.645 31.572 52.645-31.572v-63.192zM201.33 353.815v-64.803l54.07-32.422 54.067 32.422v64.803L255.4 386.24l-54.069-32.426z",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#969696",
    d: "M468.115 321.817l-52.644-31.57-52.648 31.57v63.191l52.648 31.572 52.644-31.572v-63.191zM361.4 385.814V321.01l54.07-32.422 54.066 32.422v64.803l-54.066 32.425-54.07-32.425z",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M521.47 289.818l-52.643-31.571-52.646 31.571v63.192l52.646 31.572 52.643-31.572v-63.192zm-106.712 63.997v-64.803l54.069-32.422 54.066 32.422v64.803l-54.066 32.426-54.07-32.426z",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M521.47 353.815l-52.643-31.571-52.646 31.57v63.19l52.646 31.574 52.643-31.573v-63.19zM414.758 417.81V353.01l54.069-32.425 54.066 32.425v64.801l-54.066 32.425-54.07-32.425z",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#969696",
    d: "M574.828 321.817l-52.646-31.57-52.645 31.57v63.191l52.645 31.572 52.646-31.572v-63.191zm-106.713 63.997V321.01l54.067-32.422 54.07 32.422v64.803l-54.07 32.425-54.067-32.425z",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M628.185 225.822l-52.645-31.57-52.647 31.57v63.19l52.647 31.575 52.645-31.575v-63.19zM521.47 289.82v-64.802l54.07-32.424 54.068 32.424v64.802l-54.068 32.425-54.07-32.425z",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#323232",
    d: "M468.115 193.824l-52.644-31.57-52.648 31.57v63.19l52.648 31.575 52.644-31.575v-63.19zM361.4 257.82V193.02l54.07-32.425 54.066 32.425v64.801l-54.066 32.426-54.07-32.426z",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#646464",
    d: "M414.757 225.821l-52.644-31.571-52.645 31.571v63.192l52.645 31.571 52.644-31.571V225.82zm-106.712 63.997v-64.802l54.068-32.423 54.068 32.423v64.802l-54.068 32.425-54.068-32.425z",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M465.626 129.425c0-1.767 1.432-3.198 3.2-3.198 1.768 0 3.202 1.431 3.202 3.198 0 1.768-1.434 3.201-3.202 3.201s-3.2-1.433-3.2-3.2",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#969696",
    d: "M571.271 193.421c0-2.355 1.911-4.266 4.269-4.266 2.357 0 4.267 1.91 4.267 4.266 0 2.357-1.91 4.267-4.267 4.267-2.358 0-4.269-1.91-4.269-4.267",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M465.98 321.415c0-1.572 1.275-2.845 2.847-2.845s2.845 1.273 2.845 2.845c0 1.572-1.273 2.844-2.845 2.844-1.572 0-2.847-1.272-2.847-2.844",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#323232",
    d: "M361.4 193.824l-52.643-31.57-52.645 31.57v63.19l52.645 31.575 52.644-31.575v-63.19zM254.69 257.82V193.02l54.068-32.425 54.067 32.425v64.801l-54.067 32.426-54.068-32.426z",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M359.268 193.421c0-1.571 1.274-2.843 2.844-2.843 1.574 0 2.847 1.272 2.847 2.843 0 1.573-1.273 2.845-2.847 2.845-1.57 0-2.844-1.272-2.844-2.845M197.064 225.421c0-2.75 2.23-4.978 4.98-4.978 2.749 0 4.978 2.228 4.978 4.978 0 2.749-2.23 4.977-4.979 4.977s-4.98-2.228-4.98-4.977M39.484 193.421c0-1.374 1.114-2.488 2.49-2.488 1.375 0 2.49 1.114 2.49 2.488 0 1.375-1.115 2.488-2.49 2.488-1.376 0-2.49-1.113-2.49-2.488M92.129 97.427c0-1.77 1.433-3.2 3.201-3.2s3.201 1.43 3.201 3.2c0 1.766-1.433 3.199-3.2 3.199-1.769 0-3.202-1.433-3.202-3.199M92.129 289.418c0-1.769 1.433-3.201 3.201-3.201s3.201 1.432 3.201 3.201c0 1.767-1.433 3.2-3.2 3.2-1.769 0-3.202-1.433-3.202-3.2M197.775 33.431c0-2.356 1.912-4.266 4.268-4.266 2.357 0 4.269 1.91 4.269 4.266s-1.912 4.267-4.269 4.267c-2.356 0-4.268-1.91-4.268-4.267M198.841 353.414c0-1.767 1.435-3.2 3.202-3.2 1.769 0 3.202 1.433 3.202 3.2 0 1.768-1.433 3.2-3.202 3.2-1.767 0-3.202-1.432-3.202-3.2M360.69 513.404c0-.786.636-1.422 1.423-1.422.786 0 1.422.636 1.422 1.422 0 .785-.636 1.422-1.422 1.422-.787 0-1.423-.637-1.423-1.422",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#969696",
    d: "M304.844 481.407c0-2.163 1.753-3.912 3.913-3.912s3.913 1.75 3.913 3.912c0 2.16-1.752 3.91-3.913 3.91-2.16 0-3.913-1.75-3.913-3.91",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M88.57 353.414c0-3.733 3.03-6.757 6.76-6.757 3.732 0 6.76 3.024 6.76 6.757 0 3.73-3.028 6.754-6.76 6.754-3.73 0-6.76-3.025-6.76-6.754M517.558 417.41c0-2.553 2.071-4.623 4.624-4.623 2.554 0 4.626 2.07 4.626 4.623 0 2.553-2.072 4.622-4.626 4.622-2.553 0-4.624-2.07-4.624-4.622",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#969696",
    d: "M573.05 513.404c0-1.375 1.115-2.489 2.49-2.489 1.374 0 2.49 1.114 2.49 2.489 0 1.374-1.116 2.49-2.49 2.49-1.375 0-2.49-1.116-2.49-2.49",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M142.285 449.408c0-3.538 2.867-6.4 6.402-6.4 3.536 0 6.402 2.862 6.402 6.4 0 3.533-2.866 6.4-6.402 6.4-3.535 0-6.402-2.867-6.402-6.4",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#969696",
    d: "M412.624 417.41c0-1.572 1.276-2.844 2.847-2.844 1.57 0 2.845 1.272 2.845 2.844 0 1.57-1.275 2.843-2.845 2.843-1.571 0-2.847-1.272-2.847-2.843",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#646464",
    d: "M303.065 289.418c0-3.143 2.549-5.69 5.692-5.69 3.142 0 5.691 2.547 5.691 5.69 0 3.141-2.549 5.687-5.691 5.687-3.143 0-5.692-2.546-5.692-5.687M359.268 129.425c0-1.57 1.274-2.843 2.844-2.843 1.574 0 2.847 1.274 2.847 2.843 0 1.572-1.273 2.844-2.847 2.844-1.57 0-2.844-1.272-2.844-2.844",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M414.403 33.431c0-.588.478-1.067 1.068-1.067.589 0 1.067.479 1.067 1.067 0 .59-.478 1.067-1.067 1.067-.59 0-1.068-.477-1.068-1.067",
    transform: "translate(16 54)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#323232",
    d: "M256.112 449.005L256.112 513.808 212.913 539.714 210.147 539.714 254.689 513.001 254.689 449.811 202.043 418.239 149.399 449.811 149.399 513.001 193.94 539.714 191.174 539.714 147.975 513.808 147.975 449.005 202.043 416.58z",
    transform: "translate(16 54)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgVision);
export default __webpack_public_path__ + "static/media/img-vision.e147e322e14188f46fe1694534fbe339.svg";
export { ForwardRef as ReactComponent };